 
export default defineNuxtPlugin(async (nuxtApp) => {
  const config = useRuntimeConfig()
  const  { session, refresh} = await useSession() // tvoj composable
  
  type UseKind = 'admin' | 'customer'
  type ApiOptions = Parameters<typeof $fetch>[1] & {
    token?: string
    use?: UseKind
    /** interni marker da ne uđemo u beskonačan retry */
    _retriedOnce?: boolean
  }

  const $api = $fetch.create({
    baseURL: process.server ? config.apiInternalBase : config.public.API_BASE_URL_WEB,
    credentials: 'omit',
    headers: { Accept: 'application/json' },

    async onRequest({ options }) {
      const h = (options.headers ||= {}) as HeadersInit

      // Ako je telo FormData, ne forsiraj JSON header-e
      const isFormData =
        options.body instanceof FormData ||
        (typeof FormData !== 'undefined' && options.body instanceof FormData)

      if (!isFormData) {
        // Accept već postoji; Content-Type će ofetch sam postaviti za object body
      }

      // Ako je već zadat Authorization, ne diramo
      const hasAuth =
        (h instanceof Headers && h.get('Authorization')) ||
        (Array.isArray(h) && h.find(([k]) => k.toLowerCase() === 'authorization')) ||
        (!(h instanceof Headers) && (h as any)?.Authorization)

      if (hasAuth) return

      await refresh()

      const { token, use } = options as ApiOptions
      const admin = (session.value as any)?.token
      const customer = (session.value as any)?.tokenCustomer

      // Prioritet: eksplicitni token > use: 'customer'/'admin' > admin kao default
      const bearer =
        token ??
        (use === 'customer' ? customer : use === 'admin' ? admin : admin)
       
      if (!bearer) return
      
      if (Array.isArray(h)) h.push(['Authorization', `Bearer ${bearer}`])
      else if (h instanceof Headers) h.set('Authorization', `Bearer ${bearer}`)
      else (h as any).Authorization = `Bearer ${bearer}`
    },

        async onResponseError({ response }) {

 
 
      if (response.status === 401) {
        await nuxtApp.runWithContext(() => navigateTo('/login'))
      }
      
      if (response.status === 419) {
         await nuxtApp.runWithContext(() => navigateTo('/login'))
      }

      if (response._data.message === 'User is not logged in.') {
         await nuxtApp.runWithContext(() => navigateTo('/login'))
      }

      if (response._data.message === 'Unauthenticated.') {
         await nuxtApp.runWithContext(() => navigateTo('/login'))
      }
 
    }
  })
  

  return { provide: { apiAuth: $api } }
})

  
